import BusinessUserDto from "../Common/dtos/BusinessUserDto";
import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

const useGetUsers = (options?: QueryOptions<BusinessUserDto[]>) => {
  const { selectedBusiness } = useUser();

  return useUserQuery<BusinessUserDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id}/users` },
    options);
}

export default useGetUsers;